/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type {
  ContactAttemptDto,
  ContactTracingContactDto,
  CreateContactAttemptDto,
  CreateSmsAttemptDto,
  CreateTracingContactDetailsDto,
  CreateTracingContactDto,
  GetContactTracingCompletionStatus200,
  GetTracingContactsParams,
  SetTracingContactAssessmentResultDto,
  TracingContactDetailsDto,
  TracingContactDto,
  TuberculosisHistoryDto,
  UpdateContactDetailsDto,
} from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getTracingContact = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<TracingContactDetailsDto>(
    { url: `/api/contact-tracing/tracing-contact/${id}`, method: 'GET', signal },
    options,
  );
};

export const getGetTracingContactQueryKey = (id: string) => {
  return [`/api/contact-tracing/tracing-contact/${id}`] as const;
};

export const getGetTracingContactQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContact>>> = ({ signal }) =>
    getTracingContact(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTracingContact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactQueryResult = NonNullable<Awaited<ReturnType<typeof getTracingContact>>>;
export type GetTracingContactQueryError = ErrorType<unknown>;

export function useGetTracingContact<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContact<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContact<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContact<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTracingContactSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContact>>> = ({ signal }) =>
    getTracingContact(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTracingContact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTracingContact>>>;
export type GetTracingContactSuspenseQueryError = ErrorType<unknown>;

export function useGetTracingContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTracingContact = (
  id: string,
  updateContactDetailsDto: BodyType<UpdateContactDetailsDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<TracingContactDetailsDto>(
    {
      url: `/api/contact-tracing/tracing-contact/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateContactDetailsDto,
    },
    options,
  );
};

export const getUpdateTracingContactMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTracingContact>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<UpdateContactDetailsDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateTracingContact'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTracingContact>>,
    { id: string; data: BodyType<UpdateContactDetailsDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTracingContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<UpdateContactDetailsDto> },
    TContext
  >;
};

export type UpdateTracingContactMutationResult = NonNullable<Awaited<ReturnType<typeof updateTracingContact>>>;
export type UpdateTracingContactMutationBody = BodyType<UpdateContactDetailsDto>;
export type UpdateTracingContactMutationError = ErrorType<unknown>;

export const useUpdateTracingContact = <
  TData = Awaited<ReturnType<typeof updateTracingContact>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<UpdateContactDetailsDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<UpdateContactDetailsDto> }, TContext> => {
  const mutationOptions = getUpdateTracingContactMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getTuberculosisHistory = (id: string, options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<TuberculosisHistoryDto>(
    { url: `/api/contact-tracing/tracing-contact/${id}/tuberculosis-history`, method: 'GET', signal },
    options,
  );
};

export const getGetTuberculosisHistoryQueryKey = (id: string) => {
  return [`/api/contact-tracing/tracing-contact/${id}/tuberculosis-history`] as const;
};

export const getGetTuberculosisHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTuberculosisHistoryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTuberculosisHistory>>> = ({ signal }) =>
    getTuberculosisHistory(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTuberculosisHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTuberculosisHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getTuberculosisHistory>>>;
export type GetTuberculosisHistoryQueryError = ErrorType<unknown>;

export function useGetTuberculosisHistory<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTuberculosisHistory<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTuberculosisHistory<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTuberculosisHistory<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTuberculosisHistoryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTuberculosisHistorySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTuberculosisHistoryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTuberculosisHistory>>> = ({ signal }) =>
    getTuberculosisHistory(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTuberculosisHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTuberculosisHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTuberculosisHistory>>>;
export type GetTuberculosisHistorySuspenseQueryError = ErrorType<unknown>;

export function useGetTuberculosisHistorySuspense<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTuberculosisHistorySuspense<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTuberculosisHistorySuspense<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTuberculosisHistorySuspense<
  TData = Awaited<ReturnType<typeof getTuberculosisHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTuberculosisHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTuberculosisHistorySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTuberculosisHistory = (
  id: string,
  tuberculosisHistoryDto: BodyType<TuberculosisHistoryDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<TuberculosisHistoryDto>(
    {
      url: `/api/contact-tracing/tracing-contact/${id}/tuberculosis-history`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tuberculosisHistoryDto,
    },
    options,
  );
};

export const getUpdateTuberculosisHistoryMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTuberculosisHistory>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TuberculosisHistoryDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateTuberculosisHistory'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTuberculosisHistory>>,
    { id: string; data: BodyType<TuberculosisHistoryDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTuberculosisHistory(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<TuberculosisHistoryDto> },
    TContext
  >;
};

export type UpdateTuberculosisHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTuberculosisHistory>>
>;
export type UpdateTuberculosisHistoryMutationBody = BodyType<TuberculosisHistoryDto>;
export type UpdateTuberculosisHistoryMutationError = ErrorType<unknown>;

export const useUpdateTuberculosisHistory = <
  TData = Awaited<ReturnType<typeof updateTuberculosisHistory>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<TuberculosisHistoryDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<TuberculosisHistoryDto> }, TContext> => {
  const mutationOptions = getUpdateTuberculosisHistoryMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getTracingContactContact = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<ContactTracingContactDto>(
    { url: `/api/contact-tracing/tracing-contact/${id}/contact`, method: 'GET', signal },
    options,
  );
};

export const getGetTracingContactContactQueryKey = (id: string) => {
  return [`/api/contact-tracing/tracing-contact/${id}/contact`] as const;
};

export const getGetTracingContactContactQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactContactQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContactContact>>> = ({ signal }) =>
    getTracingContactContact(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTracingContactContact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactContactQueryResult = NonNullable<Awaited<ReturnType<typeof getTracingContactContact>>>;
export type GetTracingContactContactQueryError = ErrorType<unknown>;

export function useGetTracingContactContact<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactContact<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactContact<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactContact<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactContactQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTracingContactContactSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactContactQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContactContact>>> = ({ signal }) =>
    getTracingContactContact(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTracingContactContact>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactContactSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTracingContactContact>>
>;
export type GetTracingContactContactSuspenseQueryError = ErrorType<unknown>;

export function useGetTracingContactContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactContactSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactContact>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactContact>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactContactSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateTracingContactContact = (
  id: string,
  contactTracingContactDto: BodyType<ContactTracingContactDto>,
  options?: SecondParameter<typeof request>,
) => {
  return request<ContactTracingContactDto>(
    {
      url: `/api/contact-tracing/tracing-contact/${id}/contact`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: contactTracingContactDto,
    },
    options,
  );
};

export const getUpdateTracingContactContactMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTracingContactContact>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<ContactTracingContactDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['updateTracingContactContact'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTracingContactContact>>,
    { id: string; data: BodyType<ContactTracingContactDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTracingContactContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<ContactTracingContactDto> },
    TContext
  >;
};

export type UpdateTracingContactContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTracingContactContact>>
>;
export type UpdateTracingContactContactMutationBody = BodyType<ContactTracingContactDto>;
export type UpdateTracingContactContactMutationError = ErrorType<unknown>;

export const useUpdateTracingContactContact = <
  TData = Awaited<ReturnType<typeof updateTracingContactContact>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<ContactTracingContactDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<ContactTracingContactDto> }, TContext> => {
  const mutationOptions = getUpdateTracingContactContactMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getTracingContactAttemptsByPatient = (
  patientId: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<ContactAttemptDto[]>(
    { url: `/api/contact-tracing/${patientId}/contact-attempts`, method: 'GET', signal },
    options,
  );
};

export const getGetTracingContactAttemptsByPatientQueryKey = (patientId: string) => {
  return [`/api/contact-tracing/${patientId}/contact-attempts`] as const;
};

export const getGetTracingContactAttemptsByPatientQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactAttemptsByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>> = ({ signal }) =>
    getTracingContactAttemptsByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactAttemptsByPatientQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>
>;
export type GetTracingContactAttemptsByPatientQueryError = ErrorType<unknown>;

export function useGetTracingContactAttemptsByPatient<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactAttemptsByPatient<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactAttemptsByPatient<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactAttemptsByPatient<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactAttemptsByPatientQueryOptions(patientId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTracingContactAttemptsByPatientSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactAttemptsByPatientQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>> = ({ signal }) =>
    getTracingContactAttemptsByPatient(patientId, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactAttemptsByPatientSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>
>;
export type GetTracingContactAttemptsByPatientSuspenseQueryError = ErrorType<unknown>;

export function useGetTracingContactAttemptsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactAttemptsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactAttemptsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactAttemptsByPatientSuspense<
  TData = Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>,
  TError = ErrorType<unknown>,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContactAttemptsByPatient>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactAttemptsByPatientSuspenseQueryOptions(patientId, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createContactTracingContactAttemptByPatient = (
  patientId: string,
  createContactAttemptDto: BodyType<CreateContactAttemptDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/contact-tracing/${patientId}/contact-attempts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createContactAttemptDto,
      signal,
    },
    options,
  );
};

export const getCreateContactTracingContactAttemptByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createContactTracingContactAttemptByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateContactAttemptDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createContactTracingContactAttemptByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContactTracingContactAttemptByPatient>>,
    { patientId: string; data: BodyType<CreateContactAttemptDto> }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return createContactTracingContactAttemptByPatient(patientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateContactAttemptDto> },
    TContext
  >;
};

export type CreateContactTracingContactAttemptByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContactTracingContactAttemptByPatient>>
>;
export type CreateContactTracingContactAttemptByPatientMutationBody = BodyType<CreateContactAttemptDto>;
export type CreateContactTracingContactAttemptByPatientMutationError = ErrorType<unknown>;

export const useCreateContactTracingContactAttemptByPatient = <
  TData = Awaited<ReturnType<typeof createContactTracingContactAttemptByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateContactAttemptDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { patientId: string; data: BodyType<CreateContactAttemptDto> }, TContext> => {
  const mutationOptions = getCreateContactTracingContactAttemptByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createContactTracingSmsAttemptByPatient = (
  patientId: string,
  createSmsAttemptDto: BodyType<CreateSmsAttemptDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/contact-tracing/${patientId}/contact-attempts/sms`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createSmsAttemptDto,
      signal,
    },
    options,
  );
};

export const getCreateContactTracingSmsAttemptByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createContactTracingSmsAttemptByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { patientId: string; data: BodyType<CreateSmsAttemptDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createContactTracingSmsAttemptByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContactTracingSmsAttemptByPatient>>,
    { patientId: string; data: BodyType<CreateSmsAttemptDto> }
  > = (props) => {
    const { patientId, data } = props ?? {};

    return createContactTracingSmsAttemptByPatient(patientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { patientId: string; data: BodyType<CreateSmsAttemptDto> },
    TContext
  >;
};

export type CreateContactTracingSmsAttemptByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContactTracingSmsAttemptByPatient>>
>;
export type CreateContactTracingSmsAttemptByPatientMutationBody = BodyType<CreateSmsAttemptDto>;
export type CreateContactTracingSmsAttemptByPatientMutationError = ErrorType<unknown>;

export const useCreateContactTracingSmsAttemptByPatient = <
  TData = Awaited<ReturnType<typeof createContactTracingSmsAttemptByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { patientId: string; data: BodyType<CreateSmsAttemptDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { patientId: string; data: BodyType<CreateSmsAttemptDto> }, TContext> => {
  const mutationOptions = getCreateContactTracingSmsAttemptByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const setTracingAssessmentWaitingPeriod = (
  id: BodyType<string>,
  setTracingAssessmentWaitingPeriodBody: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/contact-tracing/tracing-contact/${id}/assessment/incubation-period`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: setTracingAssessmentWaitingPeriodBody,
      signal,
    },
    options,
  );
};

export const getSetTracingAssessmentWaitingPeriodMutationOptions = <
  TData = Awaited<ReturnType<typeof setTracingAssessmentWaitingPeriod>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<string> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['setTracingAssessmentWaitingPeriod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setTracingAssessmentWaitingPeriod>>,
    { id: string; data: BodyType<string> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setTracingAssessmentWaitingPeriod(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<string> },
    TContext
  >;
};

export type SetTracingAssessmentWaitingPeriodMutationResult = NonNullable<
  Awaited<ReturnType<typeof setTracingAssessmentWaitingPeriod>>
>;
export type SetTracingAssessmentWaitingPeriodMutationBody = BodyType<string>;
export type SetTracingAssessmentWaitingPeriodMutationError = ErrorType<unknown>;

export const useSetTracingAssessmentWaitingPeriod = <
  TData = Awaited<ReturnType<typeof setTracingAssessmentWaitingPeriod>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<string> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<string> }, TContext> => {
  const mutationOptions = getSetTracingAssessmentWaitingPeriodMutationOptions(options);

  return useMutation(mutationOptions);
};
export const setTracingContactAssessmentResult = (
  id: string,
  setTracingContactAssessmentResultDto: BodyType<SetTracingContactAssessmentResultDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/contact-tracing/tracing-contact/${id}/assessment/result`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: setTracingContactAssessmentResultDto,
      signal,
    },
    options,
  );
};

export const getSetTracingContactAssessmentResultMutationOptions = <
  TData = Awaited<ReturnType<typeof setTracingContactAssessmentResult>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<SetTracingContactAssessmentResultDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['setTracingContactAssessmentResult'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setTracingContactAssessmentResult>>,
    { id: string; data: BodyType<SetTracingContactAssessmentResultDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setTracingContactAssessmentResult(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<SetTracingContactAssessmentResultDto> },
    TContext
  >;
};

export type SetTracingContactAssessmentResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof setTracingContactAssessmentResult>>
>;
export type SetTracingContactAssessmentResultMutationBody = BodyType<SetTracingContactAssessmentResultDto>;
export type SetTracingContactAssessmentResultMutationError = ErrorType<unknown>;

export const useSetTracingContactAssessmentResult = <
  TData = Awaited<ReturnType<typeof setTracingContactAssessmentResult>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<SetTracingContactAssessmentResultDto> },
    TContext
  >;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<
  TData,
  TError,
  { id: string; data: BodyType<SetTracingContactAssessmentResultDto> },
  TContext
> => {
  const mutationOptions = getSetTracingContactAssessmentResultMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getTracingContacts = (
  params?: GetTracingContactsParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<TracingContactDto[]>({ url: `/api/contact-tracing/contacts`, method: 'GET', params, signal }, options);
};

export const getGetTracingContactsQueryKey = (params?: GetTracingContactsParams) => {
  return [`/api/contact-tracing/contacts`, ...(params ? [params] : [])] as const;
};

export const getGetTracingContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContacts>>> = ({ signal }) =>
    getTracingContacts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTracingContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getTracingContacts>>>;
export type GetTracingContactsQueryError = ErrorType<unknown>;

export function useGetTracingContacts<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetTracingContactsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContacts<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContacts<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContacts<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetTracingContactsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTracingContactsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTracingContacts>>> = ({ signal }) =>
    getTracingContacts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getTracingContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTracingContactsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTracingContacts>>>;
export type GetTracingContactsSuspenseQueryError = ErrorType<unknown>;

export function useGetTracingContactsSuspense<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetTracingContactsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactsSuspense<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetTracingContactsSuspense<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetTracingContactsSuspense<
  TData = Awaited<ReturnType<typeof getTracingContacts>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTracingContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTracingContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetTracingContactsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createMultipleTracingContactsByPatient = (
  createTracingContactDetailsDto: BodyType<CreateTracingContactDetailsDto[]>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<void>(
    {
      url: `/api/contact-tracing/contacts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTracingContactDetailsDto,
      signal,
    },
    options,
  );
};

export const getCreateMultipleTracingContactsByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createMultipleTracingContactsByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTracingContactDetailsDto[]> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createMultipleTracingContactsByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMultipleTracingContactsByPatient>>,
    { data: BodyType<CreateTracingContactDetailsDto[]> }
  > = (props) => {
    const { data } = props ?? {};

    return createMultipleTracingContactsByPatient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateTracingContactDetailsDto[]> },
    TContext
  >;
};

export type CreateMultipleTracingContactsByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMultipleTracingContactsByPatient>>
>;
export type CreateMultipleTracingContactsByPatientMutationBody = BodyType<CreateTracingContactDetailsDto[]>;
export type CreateMultipleTracingContactsByPatientMutationError = ErrorType<unknown>;

export const useCreateMultipleTracingContactsByPatient = <
  TData = Awaited<ReturnType<typeof createMultipleTracingContactsByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTracingContactDetailsDto[]> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateTracingContactDetailsDto[]> }, TContext> => {
  const mutationOptions = getCreateMultipleTracingContactsByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const createTracingContactByPatient = (
  createTracingContactDto: BodyType<CreateTracingContactDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/contact-tracing/contact`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createTracingContactDto,
      signal,
    },
    options,
  );
};

export const getCreateTracingContactByPatientMutationOptions = <
  TData = Awaited<ReturnType<typeof createTracingContactByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTracingContactDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createTracingContactByPatient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTracingContactByPatient>>,
    { data: BodyType<CreateTracingContactDto> }
  > = (props) => {
    const { data } = props ?? {};

    return createTracingContactByPatient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<CreateTracingContactDto> },
    TContext
  >;
};

export type CreateTracingContactByPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTracingContactByPatient>>
>;
export type CreateTracingContactByPatientMutationBody = BodyType<CreateTracingContactDto>;
export type CreateTracingContactByPatientMutationError = ErrorType<unknown>;

export const useCreateTracingContactByPatient = <
  TData = Awaited<ReturnType<typeof createTracingContactByPatient>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<CreateTracingContactDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<CreateTracingContactDto> }, TContext> => {
  const mutationOptions = getCreateTracingContactByPatientMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getContactTracingCompletionStatus = (
  id: string,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<GetContactTracingCompletionStatus200>(
    { url: `/api/contact-tracing/tracing-contact/${id}/status`, method: 'GET', signal },
    options,
  );
};

export const getGetContactTracingCompletionStatusQueryKey = (id: string) => {
  return [`/api/contact-tracing/tracing-contact/${id}/status`] as const;
};

export const getGetContactTracingCompletionStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactTracingCompletionStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>> = ({ signal }) =>
    getContactTracingCompletionStatus(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContactTracingCompletionStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactTracingCompletionStatus>>
>;
export type GetContactTracingCompletionStatusQueryError = ErrorType<unknown>;

export function useGetContactTracingCompletionStatus<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactTracingCompletionStatus<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>,
      'initialData'
    >;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactTracingCompletionStatus<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetContactTracingCompletionStatus<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetContactTracingCompletionStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetContactTracingCompletionStatusSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContactTracingCompletionStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>> = ({ signal }) =>
    getContactTracingCompletionStatus(id, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContactTracingCompletionStatusSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getContactTracingCompletionStatus>>
>;
export type GetContactTracingCompletionStatusSuspenseQueryError = ErrorType<unknown>;

export function useGetContactTracingCompletionStatusSuspense<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactTracingCompletionStatusSuspense<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetContactTracingCompletionStatusSuspense<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetContactTracingCompletionStatusSuspense<
  TData = Awaited<ReturnType<typeof getContactTracingCompletionStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContactTracingCompletionStatus>>, TError, TData>
    >;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetContactTracingCompletionStatusSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
